export default [
	{
		dataIndex: 'created_at',
		key: 'created_at',
		title: 'Datetime',
		align: 'center',
		width: 145,
		scopedSlots: {customRender: 'datetime'}
	}, {
		key: 'webhook',
		title: 'Webhook URL',
		scopedSlots: { customRender: 'webhook'}
	}, {
		key: 'token',
		title: 'Token',
		scopedSlots: { customRender: 'token'}
	}, {
		key: 'hooks',
		title: 'Hooks',
		align: 'center',
		width: 80,
		scopedSlots: { customRender: 'hooks' }
	}, {
		key: 'state',
		title: 'State',
		align: 'center',
		width: 100,
		scopedSlots: { customRender: 'state' }
	}, {
		key: 'action',
		title: '',
		align: 'right',
		width: 100,
		scopedSlots: { customRender: 'action' }
	}
]
